import updateTree from './updateTree'

const defaultSenderRecognitions = {
  showSection: false,
  recognitions: [],
}

export default function senderRecognitions(state = {}, action) {
  switch (action.type) {
    case 'SET_SENDER_RECOGNITIONS':
      return updateTree(state, 'senderRecognitions', () => action.senderRecognitions)

    default:
      return {
        ...state,
        senderRecognitions: state.senderRecognitions ?? defaultSenderRecognitions,
      }
  }
}
